module.exports = __webpack_public_path__ + "img/wban-logo-arbitrum.b0cc1954.svg";